import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import {
    showHideModalCreateEntrega,
    updateInputs,
    createOrUpdateDocumento
} from '../../actions/documentos'
import { enums } from '../../utils/helpers'

class ModalCreateEntrega extends Component {

    handleCloseModal = () => {
        const modal = document.getElementById('modalCreateEntrega')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalCreateEntrega .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalCreateEntrega(false), 300)
    }

    render() {
        const { modalCreateEntrega, documento } = this.props
        if (!modalCreateEntrega.get('show')) {
            return null
        }
        
        return(
            <Modal id="modalCreateEntrega" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ 'Verificación de recibido' } onClose={ e => this.handleCloseModal(e, "modalCreateEntrega") } />
                <ModalButtonStrip>
                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
                        onClick={ e => this.props.createOrUpdateDocumento() }
                    />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Fecha de recibido</label>
                                    <input type="date" className="form-control input-sm" value={ moment(modalCreateEntrega.getIn(['data', 'fecha'])).format('YYYY-MM-DD') || '' } onChange={ (e) => this.props.updateInputs(`modalCreateEntrega.data.fecha`, e.target.value) } />
                                </div>
                            </div>
                        </div>
                        { (documento.get('entregas_parciales') == true) && (
                            <Fragment>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label className="control-label">Valor a facturar</label>
                                            <input type="number" className="form-control input-sm" value={ modalCreateEntrega.getIn(['data', 'valor_a_facturar']) || '' } onChange={ (e) => this.props.updateInputs(`modalCreateEntrega.data.valor_a_facturar`, e.target.value) } />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="alert alert-info">
                                            Diligencie el valor a facturar sin puntos, comas ni caracteres especiales.
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label className="control-label">Observaciones</label>
                                    <textarea className="form-control input-sm" rows={3} value={ modalCreateEntrega.getIn(['data', 'observaciones']) || '' } onChange={ (e) => this.props.updateInputs(`modalCreateEntrega.data.observaciones`, e.target.value) } />
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-md-12">
                                <h4>Evaluación del servicio recibido</h4>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-info">
                                    <div className="row">
                                        <div className="col-md-4 text-left"><strong>5 = alta</strong></div>
                                        <div className="col-md-4 text-center"><strong>3 = media</strong></div>                                
                                        <div className="col-md-4 text-right"><strong>1 = baja</strong></div> 
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-md-12">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '70%' }}>Criterio</th>
                                            <th style={{ width: '30%' }}>Calificación</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            modalCreateEntrega.getIn(['data', 'evaluaciones']).map((a, b) => {
                                                const path = ['criterios', a.get('criterio'), 'VALORES_PERMITIDOS']
                                                const options = modalCreateEntrega.getIn(path) ? modalCreateEntrega.getIn(path).split(',') : []
                                                return (
                                                    <tr key={ `tr9[${a.get('id')}]` }>
                                                        <td>{ a.get('criterio') }</td>
                                                        <td>
                                                            <select className="form-control input-sm" value={ a.get('calificacion') || 0 } onChange={ (e) => this.props.updateInputs(`modalCreateEntrega.data.evaluaciones.${b}.calificacion`, e.target.value) }>
                                                                <option value={ 0 } disabled>Seleccione una opción</option>
                                                                {
                                                                    options.map((c, d) => {
                                                                        return (
                                                                            <option key={ `opt9[${d}]` } value={ c }>{ c }</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalCreateEntrega: state.documentos.get('modalCreateEntrega'),
        documento: state.documentos.getIn(['modalSummary', 'data'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalCreateEntrega: (state) => dispatch(showHideModalCreateEntrega(state)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        createOrUpdateDocumento: () => dispatch(createOrUpdateDocumento()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateEntrega)


// WEBPACK FOOTER //
// ./src/components/Documentos/ModalCreateEntrega.jsx